export default __webpack_public_path__ + "5a2b89b191059335dd11df6417997df5.png";